import coinPng from '/img/coin-star.png';
import coinWebp from '/img/coin-star.webp';
import coinLgPng from '/img/coin-star-lg.png';
import coinLgWebp from '/img/coin-star-lg.webp';

export const capitalizationImages = {
  icon: {
    png: coinPng,
    webp: coinWebp,
  },
  iconLg: {
    png: coinLgPng,
    webp: coinLgWebp,
  },
};
